(function(){'use strict';var cfg=window.LMP_NATIVE_CONFIG||window.LMP_APP_CONFIG||{};var deferred=null,shown=false,timer=null,prefetched={};function root(){return document.getElementById('lmp-native-app')}function siteLogo(){var i=document.querySelector('.header__heading-logo:not(.header__heading-logo--transparent)');return i&&(i.currentSrc||i.src)||cfg.logoUrl||''}function syncLogo(){var s=siteLogo();if(!s)return;document.querySelectorAll('#lmp-native-app .lmp-logo,#lmp-native-app .lmp-splash-logo img,.lmp-test-install__logo').forEach(function(i){if(i.tagName==='IMG'&&i.src!==s){i.src=s;i.removeAttribute('width');i.removeAttribute('height')}})}function num(v){v=Number(v);return isFinite(v)?v:0}function pct(p,c){p=num(p);c=num(c);return c>p&&p>0?Math.max(1,Math.round((1-p/c)*100)):0}if(typeof window.productCard==='function'){var oldCard=window.productCard;window.productCard=function(p,d){var h=oldCard.apply(this,arguments);try{var x=pct(p&&p.price,p&&p.compare_at_price);if(x&&h.indexOf('lmp-badge--sale')<0)h=h.replace(/(<div class=\"lmp-product-card__media\"[^>]*>)/,'$1<span class=\"lmp-badge lmp-badge--sale\">-'+x+'%</span>')}catch(e){}return h}}function enhanceProduct(p){var r=root();if(!r)return;r.querySelectorAll('#lmp-buy-now,[data-lmp-buy-now],.lmp-buy-now').forEach(function(e){e.remove()});var hero=r.querySelector('.lmp-product-hero');if(!hero||!p)return;var b=hero.querySelector('.lmp-product-sale-badge');if(!b){b=document.createElement('span');b.className='lmp-product-sale-badge';hero.appendChild(b)}function current(){var vs=p.variants||[],s=r.querySelector('#lmp-variant-select,[data-lmp-variant-select]'),id=s?String(s.value||''):'';for(var i=0;i<vs.length;i++)if(String(vs[i].id)===id)return vs[i];return vs[0]||p}function up(){var v=current(),x=pct(v.price!=null?v.price:p.price,v.compare_at_price!=null?v.compare_at_price:p.compare_at_price);if(x){b.textContent='-'+x+'%';b.hidden=false}else b.hidden=true}up();var s=r.querySelector('#lmp-variant-select,[data-lmp-variant-select]');if(s&&!s.dataset.lmpSale){s.dataset.lmpSale='1';s.addEventListener('change',up)}syncLogo()}if(typeof window.buildProductView==='function'){var oldBuild=window.buildProductView;window.buildProductView=function(p){var z=oldBuild.apply(this,arguments);try{enhanceProduct(p)}catch(e){}return z}}window.setBadges=function(c){c=Math.max(0,Number(c)||0);var t=c>99?'99+':String(c);document.querySelectorAll('[data-lmp-cart-badge],[data-lmp-cart-top]').forEach(function(b){b.textContent=t;b.hidden=false;b.removeAttribute('hidden')})};var cartRefreshInFlight=false,cartRefreshLast=0;window.refreshCartBadge=function(){if(!window.fetch)return;var now=Date.now();if(cartRefreshInFlight||now-cartRefreshLast<350)return;cartRefreshInFlight=true;cartRefreshLast=now;fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw 0;return r.json()}).then(function(c){window.setBadges(c&&c.item_count)}).catch(function(){}).finally(function(){cartRefreshInFlight=false})};function standalone(){return !!cfg.standalone||(window.matchMedia&&window.matchMedia('(display-mode: standalone)').matches)||navigator.standalone===true}function mobile(){return window.matchMedia?window.matchMedia('(max-width: 989px)').matches:innerWidth<990}function schedule(){}/* Suppression du fetch speculatif au pointerdown : ne plus concurrencer le clic client. */function init(){if(!standalone()&&!cfg.previewMode){schedule();return;}syncLogo();window.refreshCartBadge();window.addEventListener('pageshow',window.refreshCartBadge);window.addEventListener('focus',window.refreshCartBadge);document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible')window.refreshCartBadge()});var r=root();if(r&&window.MutationObserver)(function(){var logoQueued=false;new MutationObserver(function(changes){if(logoQueued)return;
var hasLogo=changes.some(function(c){return Array.prototype.some.call(c.addedNodes,function(n){return n.nodeType===1&&((n.matches&&n.matches('.lmp-logo,.lmp-splash-logo img,.lmp-test-install__logo'))||(n.querySelector&&n.querySelector('.lmp-logo,.lmp-splash-logo img,.lmp-test-install__logo')));});});
if(!hasLogo)return;logoQueued=true;requestAnimationFrame(function(){logoQueued=false;syncLogo()});
}).observe(r,{childList:true,subtree:true});})();setTimeout(function(){syncLogo();window.refreshCartBadge();document.querySelectorAll('#lmp-buy-now,[data-lmp-buy-now],.lmp-buy-now').forEach(function(e){e.remove()})},650);schedule()}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();if(document.readyState==='complete')schedule();else window.addEventListener('load',schedule,{once:true})})();
;(function(){
  'use strict';
  var cfg=window.LMP_NATIVE_CONFIG||window.LMP_APP_CONFIG||{};
  if(!cfg.standalone&&!cfg.previewMode)return;
  function appRoot(){return document.getElementById('lmp-native-app')}
  function normalizedPath(v){return (v||'/').replace(/\/+$/,'')||'/'}

  function fixBottomNavActive(){
    var r=appRoot(),nav=r&&r.querySelector('.lmp-native-nav');
    if(!nav)return;
    var p=normalizedPath(location.pathname),target='/';
    if(p==='/cart')target='/cart';
    else if(p==='/search')target='/search';
    else if(p==='/pages/categories-parapharmacie'||p==='/pages/marques'||p.indexOf('/collections/')===0)target='/pages/categories-parapharmacie';
    else if(p.indexOf('/account')===0)target='/account';
    nav.querySelectorAll('a[href]').forEach(function(a){
      var ap='/';
      try{ap=normalizedPath(new URL(a.href,location.href).pathname)}catch(e){}
      a.classList.toggle('is-active',ap===target);
    });
  }

  function applyFreeShippingState(cart){
    var r=appRoot();
    if(!r||!cart)return;
    var national=Number(cfg.freeShippingNational||49900);
    var total=Number(cart.total_price||0);
    var free=total>=national;
    var box=r.querySelector('.lmp-cart-progress');
    if(box){
      box.classList.toggle('is-pending',!free);
      box.classList.toggle('is-free-reached',free);
      if(free){
        var copy=box.querySelector('.lmp-cart-progress__copy');
        if(copy){
          var small=copy.querySelector('small');
          var smallHtml=small?'<br><small>'+small.innerHTML+'</small>':'';
          copy.innerHTML='<strong class=\"lmp-free-shipping-title\">Livraison Gratuite</strong>'+smallHtml;
        }
      }
    }
    if(free){
      var summary=r.querySelector('.lmp-summary__row.is-free strong');
      if(summary){
        summary.textContent='Gratuite';
        summary.classList.add('lmp-free-shipping-summary');
      }
    }
    fixBottomNavActive();
  }

  if(typeof window.buildCart==='function'){
    var oldBuildCart=window.buildCart;
    window.buildCart=function(cart){
      var z=oldBuildCart.apply(this,arguments);
      try{applyFreeShippingState(cart)}catch(e){}
      return z;
    };
  }

  function refreshCartState(){
    if(normalizedPath(location.pathname)!=='/cart'||!window.fetch)return;
    fetch('/cart.js?lmp_ui='+Date.now(),{
      credentials:'same-origin',
      cache:'no-store',
      headers:{Accept:'application/json'}
    }).then(function(r){
      if(!r.ok)throw 0;
      return r.json();
    }).then(applyFreeShippingState).catch(function(){});
  }

  function syncUi(){
    fixBottomNavActive();
    refreshCartState();
  }

  function observeUi(){
    if(!window.MutationObserver||!document.body)return;
    var queued=false;
    new MutationObserver(function(mutations){
      if(queued)return;
      var navChanged=mutations.some(function(m){
        return Array.prototype.some.call(m.addedNodes,function(n){
          return n.nodeType===1&&((n.matches&&n.matches('.lmp-native-nav'))||(n.querySelector&&n.querySelector('.lmp-native-nav')));
        });
      });
      if(!navChanged)return;
      queued=true;
      requestAnimationFrame(function(){
        queued=false;
        fixBottomNavActive();
      });
    }).observe(document.body,{childList:true,subtree:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){syncUi();observeUi()},{once:true});
  }else{
    syncUi();
    observeUi();
  }
  window.addEventListener('pageshow',syncUi);
})();
